import pick from 'lodash/pick'

import { transformValue } from './transformers'

const getConfigFromDocData = data => {
  const config = pick(data, [
    'active',
    'key',
    'namespace',
    'public',
    'type',
    'value'
  ])
  return {
    ...config,
    name: `${config.namespace}-${config.key}`.toLowerCase(),
    value: transformValue(config)
  }
}

const setFeatureConfigs = (state, docs) => {
  if (!docs) return
  const configs = docs.map(doc => getConfigFromDocData(doc.data()))
  Object.assign(state, { configs })
}

const updateFeatureConfig = (state, data) => {
  if (!data) return
  const configs = [...state.configs]
  const updatedConfig = getConfigFromDocData(data)
  const index = configs.findIndex(c => c.name === updatedConfig.name)
  if (index < 0) state.configs.push(updatedConfig)
  else Object.assign(state.configs[index], updatedConfig)
}

const setNotification = (state, { name, message }) => {
  let index = state.notifications.findIndex(c => c.name === name)
  if (index < 0) index = state.notifications.length
  state.notifications[index] = { name, message }
}

const setListener = (state, listener) => {
  Object.assign(state, { listener })
}

export default {
  setFeatureConfigs,
  setNotification,
  setListener,
  updateFeatureConfig
}
